import React, { createContext, useReducer, useEffect, useState, useContext } from 'react'
import CookiePopup from './CookiePopup'

const COOKIE_NAME = 'consent'

const CookieConsentStateContext = createContext()

function getCookie() {
  const regex = new RegExp(`(?:(?:^|.*;\\s*)${COOKIE_NAME}\\s*\\=\\s*([^;]*).*$)|^.*$`)
  const cookie = document.cookie.replace(regex, "$1");
  return cookie.length ? JSON.parse(cookie) : undefined
}

// Initial value is cookie value OR prefered value but not yet set
let initialCookieValue = getCookie() || {
  isSet: 0,
  marketing: 0,
  analitika: 0,
}

const CookieConsentProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'acceptCurrent':
        return {
          analitika: action.payload.analytics ? 1 : 0,
          marketing: action.payload.marketing ? 1 : 0,
          isSet: 1,
        }
      case 'declineAll':
        return {
          analitika: 0,
          isSet: 1,
          marketing: 0,
        }
      case 'showCookiePopup':
        return state
      default:
        throw new Error()
    }
  }, initialCookieValue)

  // Update the cookie when state changes
  useEffect(() => {
    var now = new Date();
    var expDate = new Date(now.setMonth(now.getMonth() + 1)).toUTCString();
    if (document?.cookie) {
      var cookiesArray = document.cookie.split(";")
      for (var i = 0; i < cookiesArray.length; i++) {
        var oldCookie = cookiesArray[i].split("=");
        var oldCookieData;
        if (oldCookie?.length > 1) {
          try {
            oldCookieData = JSON.parse(oldCookie[1]);
          } catch (e) {
            continue;
          }
          if (oldCookie[0] === COOKIE_NAME && oldCookieData?.expDate) {
            expDate = oldCookieData.expDate;
            break;
          }
        }
      }
    }

    var newState = {...state, expDate};

    document.cookie = `${COOKIE_NAME}=${JSON.stringify(newState)};expires=${expDate};path=/`;
    if (state.isSet) {
      if (state.analitika) {
        window.gtag('consent', 'update', {
          'ad_storage': 'granted',
          'analytics_storage': 'granted'
        });
      }
      if (state.marketing) {
        if ('fbq' in window) {
          setTimeout(() => {
            window.fbq('consent', 'grant');
            window.fbq('track', 'PageView');
          }, 2000)
          
        }

      }
      //document.cookie = `ba_vid=${1};max-age=${60*60*24*365*1.5} `
      //document.cookie = `ba_sid=${1};max-age=${60*30}`
    }
  }, [state])

  return (
    <CookieConsentStateContext.Provider value={state}>
      {(!state.isSet && window.location.pathname.startsWith(process.env.PUBLIC_URL + '/event')) && <CookiePopup dispatch={dispatch} />}
      {children}
    </CookieConsentStateContext.Provider>
  )

}


export { CookieConsentProvider, CookieConsentStateContext }